import { memo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { keyframes, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import logo from '../../assets/images/new-logo.svg';

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.95);
    opacity: 0.7;
  }
`;

const Content = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
}));

const StyledImg = styled('img')({
  animationName: `${pulse}`,
  animationDuration: '1.5s',
  animationDirection: 'alternate',
  animationIterationCount: 'infinite',
  WebkitAnimationName: `${pulse}`,
  WebkitAnimationDuration: '1.5s',
  WebkitAnimationIterationCount: 'infinite',

  '&.stopPulse': {
    animationName: 'none',
  },
});

function SplashScreen({ showTryAgain = false, onTryAgain = () => {} }) {
  return (
    <Content>
      <StyledImg width="250" src={logo} alt="Logo" className={showTryAgain ? 'stopPulse' : ''} />
      {showTryAgain && (
        <Box mt={2}>
          <Button variant="contained" color="primary" size="small" onClick={onTryAgain}>
            try again
          </Button>
        </Box>
      )}
    </Content>
  );
}

export default memo(SplashScreen);
